<template>
  <div
    class="predicted-apply-detail-page main-layout prediect-major-detail-page"
  >
    <el-card class="box-inner">
      <c-title slot="header" title="详情" :back="true" />
      <div class="div-scroll">
        <div class="content-container">
          <div class="history-container">
            <c-table
              :data="pageData"
              :tableColumns="tableColumns"
              v-loading="pageLoading"
            >
            </c-table>
          </div>
          <div class="detail-container">
            <el-row>
              <el-col :span="4">姓名</el-col>
              <el-col :span="20">{{ detailInfo.studentName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">身份证号</el-col>
              <el-col :span="20">{{ studentInfo.idCard }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">录取专业</el-col>
              <el-col :span="20">{{ detailInfo.originalMajorName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">学生类别</el-col>
              <el-col :span="20">{{ studentInfo.typeName }}</el-col>

              <!-- <el-col :span="20">{{ studentType[studentInfo.type] }}</el-col> -->
            </el-row>
            <el-row>
              <el-col :span="4">学生省份</el-col>
              <el-col :span="20">{{ studentInfo.sourceProvince }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">考生号</el-col>
              <el-col :span="20">{{ studentInfo.examNumber }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">高考分数</el-col>
              <el-col :span="20">{{ studentInfo.examScore }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">拟调配专业</el-col>
              <el-col :span="20">{{ detailInfo.applyMajorName }}</el-col>
            </el-row>
            <div class="operation-btn" v-if="type == 'todo'">
              <el-button
                type="success"
                @click="handleChange(true)"
                :disabled="isSubmit"
                >通过</el-button
              >
              <el-button
                type="danger"
                @click="dialogFormVisible = true"
                :disabled="isSubmit"
                >拒绝</el-button
              >
            </div>
            <el-row style="padding-top: 20px">
              <el-col :span="4">审批详情：</el-col>
              <el-col :span="20">
                <div class="step-container">
                  <el-timeline>
                    <el-timeline-item
                      v-for="(item, index) in processInfo"
                      :key="index"
                      color="#0bbd87"
                      placement="bottom"
                      :hide-timestamp="false"
                    >
                      <p>
                        {{ item.type == "TJ" ? item.message : item.taskName }}
                      </p>
                      <p>
                        [{{ item.userName }}][{{ item.typeName }}][{{
                          item.time
                        }}]
                      </p>
                      <!-- <p>
                      <span v-if="item.taskName">{{ item.taskName }}</span>
                      {{ item.message }}
                    </p> -->
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog :append-to-body='true' title="拒绝" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="cForm" label-width="100px">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="form.reason" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/major";
let mPage = MPage({
  pagePath: "/oa/welcome/exchangeMajor/getHistoryList",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  mixins: [mPage],
  data() {
    let { tableColumnsHistory } = Configs(this);
    return {
      SUCCESS_CODE: "",
      tableColumns: tableColumnsHistory,
      studentId: "",
      studentInfo: {},
      detailInfo: {},
      processInfo: [],
      type: "",
      isSubmit: false,
      dialogFormVisible: false,
      rules: {
        reason: [{ required: true, message: "请输入原因", trigger: "blur" }],
      },
      form: { reason: "" },
      studentType: {
        0: "普通学生",
        1: "体育生",
        2: "单招",
        3: "艺术生",
        4: "技能类",
      },
      userId: "",
      taskId: "",
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    let id = this.$route.query.id;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userId = userInfo.id;
    this.type = this.$route.query.type;
    this.taskId = this.$route.query.taskId;
    this.studentId = this.$route.query.studentId;
    this.getStudentInfo(this.studentId);
    this.getDetailInfo(id); // 获取审批详情
    this.getProcessInfo(id); // 获取审批流程详情
  },
  mounted() {},
  methods: {
    pageGetBeforeFn(data) {
      data.studentId = this.studentId;
    },
    pageGetAfterFn(data) {
      let pageData = {};
      pageData.records = data;
      // data.records = data;
      return pageData;
    },
    // 获取学生基本信息详情
    getStudentInfo(id) {
      this.$http
        .get("/account/base/student/studentId", { params: { studentId: id } })
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.studentInfo = res.data;
            // this.isLoading = false;
          } else {
            // this.isLoading = false;
            this.$message.error(`获取数据失败，${res.msg}`);
          }
        })
        .catch((err) => {
          // this.isLoading = false;
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 获取流程详情
    getDetailInfo(id) {
      let params = {
        processInstanceId: id,
      };
      this.$http
        .get("/oa/welcome/exchangeMajor/getByProcessInstanceId", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.detailInfo = res.data;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 处理申请
    handleChange(status) {
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isSubmit = true;
          let params = {
            // forecastLinkId: this.detailInfo.forecastLinkId,
            isPass: status,
            message: status ? "" : this.form.reason,
            taskId: this.taskId,
            processInstanceId: this.detailInfo.processInstanceId,
            userId: this.userId,
          };
          this.$http
            .post("/oa/welcome/exchangeMajor/complete", params)
            .then((res) => {
              if (res.code == this.SUCCESS_CODE) {
                this.$message.success("操作成功");
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
              this.isSubmit = false;
            })
            .catch((err) => {
              this.isSubmit = false;
              this.$message.error(err);
            });
        })
        .catch(() => {});
    },
    // 确认驳回
    handleConfirm() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.handleChange(false);
        } else {
          return false;
        }
      });
    },
    // 确认取消驳回
    handleCancel() {
      this.$refs["cForm"].resetFields();
      this.dialogFormVisible = false;
    },
    // 获取审批详情
    getProcessInfo(id) {
      this.$http
        .get("/oa/processInstance/findCommentsByProcessInstanceId/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.processInfo = res.data;
          } else {
            this.processInfo = [];
          }
        })
        .catch((err) => {
          this.processInfo = [];
        });
    },
    // 获取换专业历史详情
  },
};
</script>
